import LoginComponent from "../components/Auth/LoginComponent";

export default function LoginPage (){

    return (
        <>
        <LoginComponent/>
        </>
    )
}